/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Problem_1_TitleInputs */

const en_mk_problem_1_title = /** @type {(inputs: Mk_Problem_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI used in the shadows`)
};

const id_mk_problem_1_title = /** @type {(inputs: Mk_Problem_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI dipakai diam-diam`)
};

/**
* | output |
* | --- |
* | "AI used in the shadows" |
*
* @param {Mk_Problem_1_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_problem_1_title = /** @type {((inputs?: Mk_Problem_1_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Problem_1_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_problem_1_title(inputs)
	return en_mk_problem_1_title(inputs)
});